const stylesInputLabel = {
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: 600,
    fontFamily: "Raleway, sans-serif",
  },
  select: {
    padding: "8px",
    border: "none",
    color: "gray",
    outline: "none",
    borderRadius: "7px",
  },
  input: {
    padding: "8px",
    backgroundColor: "#edeff2",
    border: "none",
    color: "gray",
    outline: "none",
    borderRadius: "7px",
  },
  error: {
    color: "red",
    fontSize: "12px",
    marginTop: "5px",
  },
};

export default stylesInputLabel;
